import {
  IsString,
  IsNotEmpty,
  IsOptional,
  IsBoolean,
  IsInt,
  IsIn,
  MaxLength,
  IsUrl,
  Min,
} from 'class-validator';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

export const AYUDA_TIPOS = ['documento', 'video'] as const;
export const AYUDA_TIPOS_DOCUMENTO = ['pdf', 'docx'] as const;

export class CreateAyudaDto {
  @ApiProperty({
    example: 'Manual de usuario OPB',
    description: 'Título de la ayuda',
    maxLength: 200,
  })
  @IsString()
  @IsNotEmpty()
  @MaxLength(200)
  readonly titulo!: string;

  @ApiProperty({
    example: 'documento',
    description: 'Tipo: documento (archivo PDF/Word) o video (enlace YouTube)',
    enum: AYUDA_TIPOS,
  })
  @IsString()
  @IsIn(AYUDA_TIPOS)
  readonly tipo!: (typeof AYUDA_TIPOS)[number];

  /**
   * Para tipo video: URL de YouTube. Para tipo documento se envía por multipart (archivo).
   */
  @ApiPropertyOptional({
    example: 'https://www.youtube.com/watch?v=xxxxx',
    description: 'URL de YouTube (obligatorio si tipo=video)',
  })
  @IsOptional()
  @IsString()
  @IsUrl()
  @MaxLength(1000)
  readonly url?: string;

  @ApiPropertyOptional({
    example: 'Tutorial de uso del módulo de liquidaciones',
    description: 'Descripción opcional',
  })
  @IsOptional()
  @IsString()
  readonly descripcion?: string;

  @ApiPropertyOptional({ example: true, default: true })
  @IsOptional()
  @IsBoolean()
  readonly activo?: boolean;

  @ApiPropertyOptional({ example: 0, default: 0 })
  @IsOptional()
  @IsInt()
  @Min(0)
  readonly orden?: number;
}

export class UpdateAyudaDto {
  @ApiPropertyOptional({
    example: 'Manual de usuario OPB',
    description: 'Título de la ayuda',
    maxLength: 200,
  })
  @IsOptional()
  @IsString()
  @MaxLength(200)
  readonly titulo?: string;

  @ApiPropertyOptional({
    example: 'video',
    description: 'Tipo: documento o video',
    enum: AYUDA_TIPOS,
  })
  @IsOptional()
  @IsString()
  @IsIn(AYUDA_TIPOS)
  readonly tipo?: (typeof AYUDA_TIPOS)[number];

  @ApiPropertyOptional({
    example: 'https://www.youtube.com/watch?v=xxxxx',
    description: 'URL de YouTube (si tipo=video)',
  })
  @IsOptional()
  @IsString()
  @MaxLength(1000)
  readonly url?: string;

  @ApiPropertyOptional({ description: 'Descripción opcional' })
  @IsOptional()
  @IsString()
  readonly descripcion?: string;

  @ApiPropertyOptional()
  @IsOptional()
  @IsBoolean()
  readonly activo?: boolean;

  @ApiPropertyOptional()
  @IsOptional()
  @IsInt()
  @Min(0)
  readonly orden?: number;
}

export class AyudaResponseDto {
  @ApiProperty()
  id!: string;

  @ApiProperty()
  titulo!: string;

  @ApiProperty({ enum: AYUDA_TIPOS })
  tipo!: string;

  @ApiProperty({ description: 'Ruta del archivo o URL de video' })
  urlOrPath!: string;

  @ApiPropertyOptional({ enum: AYUDA_TIPOS_DOCUMENTO })
  tipoDocumento?: string | null;

  @ApiPropertyOptional()
  descripcion?: string | null;

  @ApiProperty()
  activo!: boolean;

  @ApiProperty()
  orden!: number;

  @ApiProperty()
  createdAt!: string;

  @ApiPropertyOptional()
  updatedAt?: string;
}
